import { NEWS_PAGE_SIZE } from "../constants/content";
import { buildNewsDetailPath, buildPolicyPath } from "../constants/routes";
import {
  NewsArticleDetail,
  NewsCategory,
  NewsListQuery,
  NewsListResult,
  PolicyNavItem,
  PolicyPage,
  ProductFilters,
  SeoMetadata,
} from "../types";

export interface MockCollectionPage {
  slug: string;
  title: string;
  description: string;
  highlights: string[];
  filters: ProductFilters;
}

const NEWS_LISTING_SEO: SeoMetadata = {
  title: "Tin tức ERP GOLD",
  description:
    "Cập nhật xu hướng trang sức, tư vấn chọn quà tặng và kiến thức bảo quản theo phong cách nội dung từ Ancarat.",
  pathname: "/tin-tuc",
  image: "/home/ancarat-flashsale.png",
  type: "website",
  keywords: ["tin tuc trang suc", "xu huong vang", "tu van mua trang suc"],
};

const createNewsItem = (
  item: Omit<NewsArticleDetail, "href" | "seo">,
): NewsArticleDetail => ({
  ...item,
  href: buildNewsDetailPath(item.slug),
  seo: {
    title: item.title,
    description: item.excerpt,
    pathname: buildNewsDetailPath(item.slug),
    image: item.image,
    type: "article",
  },
});

const createPolicyPage = (
  page: Omit<PolicyPage, "seo"> & { seoDescription?: string },
): PolicyPage => ({
  ...page,
  seo: {
    title: `${page.title} | ERP GOLD`,
    description: page.seoDescription ?? page.description,
    pathname: buildPolicyPath(page.slug),
    image: page.thumbnail,
    type: "website",
  },
});

const toPositiveInteger = (value: number | undefined, fallback: number) => {
  if (!Number.isFinite(value)) {
    return fallback;
  }

  return Math.max(1, Math.floor(value as number));
};

export const mockNewsCategories: NewsCategory[] = [
  {
    id: "news-cat-trend",
    label: "Xu hướng",
    slug: "xu-huong",
    description:
      "Những chuyển động mới trong gu thẩm mỹ và thói quen mua trang sức.",
  },
  {
    id: "news-cat-consulting",
    label: "Tư vấn chọn mua",
    slug: "tu-van-chon-mua",
    description:
      "Gợi ý chọn nhẫn, dây chuyền và quà tặng theo tình huống mua hàng.",
  },
  {
    id: "news-cat-care",
    label: "Kiến thức bảo quản",
    slug: "kien-thuc-bao-quan",
    description:
      "Mẹo giữ độ bóng, độ bền và giá trị sử dụng của sản phẩm kim hoàn.",
  },
];

export const mockNewsArticles: NewsArticleDetail[] = [
  createNewsItem({
    id: "news-01",
    title: "5 xu hướng trang sức cưới được tìm kiếm nhiều nhất đầu mùa lễ",
    slug: "5-xu-huong-trang-suc-cuoi-duoc-tim-kiem-nhieu-nhat",
    excerpt:
      "Thiết kế mảnh, bề mặt sáng và khả năng phối set đang là ba yếu tố khiến khách hàng chốt mua nhanh hơn trên storefront.",
    sapo: "Thiết kế mảnh, bề mặt sáng và khả năng phối set đang là ba yếu tố khiến khách hàng chốt mua nhanh hơn trên storefront.",
    image:
      "https://images.unsplash.com/photo-1617038260897-41a1f14a8ca0?auto=format&fit=crop&w=1400&q=80",
    category: "Xu hướng",
    categorySlug: "xu-huong",
    publishedAt: "2026-04-21T09:00:00.000Z",
    author: "ERP GOLD Editorial",
    htmlContent: `
      <p>Mùa cưới năm nay ghi nhận nhu cầu cao với các mẫu nhẫn có bản mảnh, bề mặt sáng và dễ phối thành set cùng vòng tay hoặc dây chuyền.</p>
      <h3>Điểm khách hàng quan tâm nhất</h3>
      <ul>
        <li>Thiết kế không lỗi mốt khi xem ảnh cận tay.</li>
        <li>Dễ đeo hàng ngày sau lễ cưới.</li>
        <li>Giữ được cảm giác sang trọng nhưng không quá phô trương.</li>
      </ul>
      <p>Trên storefront, các mẫu có ảnh close-up rõ chất liệu và caption ngắn thường có tỷ lệ chuyển đổi tốt hơn nhóm trình bày quá nhiều thông tin kỹ thuật.</p>
    `,
  }),
  createNewsItem({
    id: "news-02",
    title: "Vì sao bộ sưu tập capsule giúp trang sức bán tốt hơn trên mobile",
    slug: "vi-sao-bo-suu-tap-capsule-giup-trang-suc-ban-tot-hon-tren-mobile",
    excerpt:
      "Cách nhóm sản phẩm theo bộ ngắn giúp người mua online so sánh nhanh, giảm mỏi mắt và ra quyết định sớm hơn.",
    sapo: "Cách nhóm sản phẩm theo bộ ngắn giúp người mua online so sánh nhanh, giảm mỏi mắt và ra quyết định sớm hơn.",
    image:
      "https://images.unsplash.com/photo-1506630448388-4e683c67ddb0?auto=format&fit=crop&w=1400&q=80",
    category: "Xu hướng",
    categorySlug: "xu-huong",
    publishedAt: "2026-04-20T11:30:00.000Z",
    author: "ERP GOLD Editorial",
    htmlContent: `
      <p>Capsule collection giúp khách online quét nhanh một nhóm sản phẩm có cùng tinh thần thiết kế và ngân sách gần nhau.</p>
      <p>Thay vì phải so sánh quá nhiều lựa chọn rời rạc, người mua nhìn được bức tranh tổng thể và chốt nhanh hơn ở mobile.</p>
      <h3>Ứng dụng trên trang bán hàng</h3>
      <p>Danh sách sản phẩm nên giữ hình ảnh nhất quán, title ngắn và CTA rõ ràng để capsule phát huy hiệu quả.</p>
    `,
  }),
  createNewsItem({
    id: "news-03",
    title:
      "Bảng màu vàng trắng và vàng champagne đang quay lại trong quà tặng cao cấp",
    slug: "bang-mau-vang-trang-va-vang-champagne-dang-quay-lai-trong-qua-tang-cao-cap",
    excerpt:
      "Khách mua quà tặng ưu tiên tông màu dễ phối trang phục và có cảm giác sang nhưng không quá phô trương.",
    sapo: "Khách mua quà tặng ưu tiên tông màu dễ phối trang phục và có cảm giác sang nhưng không quá phô trương.",
    image:
      "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?auto=format&fit=crop&w=1400&q=80",
    category: "Xu hướng",
    categorySlug: "xu-huong",
    publishedAt: "2026-04-18T08:15:00.000Z",
    author: "Minh An",
    htmlContent: `
      <p>Vàng trắng và champagne đang được chọn nhiều trong nhóm quà tặng cao cấp vì cân bằng giữa sự hiện đại và độ dễ phối đồ.</p>
      <p>Khách hàng thích các gam màu ít rủi ro hơn khi mua online, đặc biệt với các dịp sinh nhật, kỷ niệm và quà doanh nghiệp.</p>
    `,
  }),
  createNewsItem({
    id: "news-04",
    title: "Cách chọn nhẫn cưới theo tông da để ảnh chụp cận tay đẹp hơn",
    slug: "cach-chon-nhan-cuoi-theo-tong-da-de-anh-chup-can-tay-dep-hon",
    excerpt:
      "Từ màu vàng 14K đến vàng 18K, từng sắc độ kim loại tạo cảm giác rất khác khi lên ảnh cưới và video ngắn.",
    sapo: "Từ màu vàng 14K đến vàng 18K, từng sắc độ kim loại tạo cảm giác rất khác khi lên ảnh cưới và video ngắn.",
    image:
      "https://images.unsplash.com/photo-1602173574767-37ac01994b2a?auto=format&fit=crop&w=1400&q=80",
    category: "Tư vấn chọn mua",
    categorySlug: "tu-van-chon-mua",
    publishedAt: "2026-04-17T14:10:00.000Z",
    author: "Ngọc Hà",
    htmlContent: `
      <p>Tông da ảnh hưởng rất nhiều đến cảm nhận của vàng khi chụp cận tay, đặc biệt với nhẫn cưới bản mảnh.</p>
      <ul>
        <li>Tông da sáng thường hợp vàng trắng, champagne hoặc 14K sáng nhẹ.</li>
        <li>Tông da ấm hợp vàng 18K truyền thống hoặc vàng hồng.</li>
      </ul>
      <p>Nếu khách chốt online, nên dùng ảnh thật với ánh sáng trung tính để tránh lệch màu kỳ vọng.</p>
    `,
  }),
  createNewsItem({
    id: "news-05",
    title: "3 cách xây set quà tặng trang sức cho ngân sách dưới 15 triệu",
    slug: "3-cach-xay-set-qua-tang-trang-suc-cho-ngan-sach-duoi-15-trieu",
    excerpt:
      "Ghép charm, nhẫn mảnh và dây chuyền nền cơ bản giúp cửa hàng tạo cảm giác chỉn chu mà vẫn kiểm soát được giá trị đơn.",
    sapo: "Ghép charm, nhẫn mảnh và dây chuyền nền cơ bản giúp cửa hàng tạo cảm giác chỉn chu mà vẫn kiểm soát được giá trị đơn.",
    image:
      "https://images.unsplash.com/photo-1515562141207-7a88fb7ce338?auto=format&fit=crop&w=1400&q=80",
    category: "Tư vấn chọn mua",
    categorySlug: "tu-van-chon-mua",
    publishedAt: "2026-04-16T10:00:00.000Z",
    author: "Ngọc Hà",
    htmlContent: `
      <p>Ngân sách dưới 15 triệu vẫn đủ để xây các set quà tặng có cảm giác chỉn chu nếu biết ưu tiên đúng cấu phần.</p>
      <p>Một combo phổ biến là dây chuyền nền cơ bản, charm nhỏ và hộp quà cá nhân hóa. Cách đóng gói và thông điệp tặng quà giúp nâng cảm nhận giá trị rõ rệt.</p>
    `,
  }),
  createNewsItem({
    id: "news-06",
    title: "Chọn dây chuyền quà sinh nhật: ưu tiên độ dài hay điểm nhấn mặt đá",
    slug: "chon-day-chuyen-qua-sinh-nhat-uu-tien-do-dai-hay-diem-nhan-mat-da",
    excerpt:
      "Nếu khách chốt quà online, độ dài dễ đeo thường quan trọng hơn mặt đá lớn vì giảm rủi ro phải đổi trả sau nhận hàng.",
    sapo: "Nếu khách chốt quà online, độ dài dễ đeo thường quan trọng hơn mặt đá lớn vì giảm rủi ro phải đổi trả sau nhận hàng.",
    image:
      "https://images.unsplash.com/photo-1599643478518-a784e5dc4c8f?auto=format&fit=crop&w=1400&q=80",
    category: "Tư vấn chọn mua",
    categorySlug: "tu-van-chon-mua",
    publishedAt: "2026-04-14T09:45:00.000Z",
    author: "Minh An",
    htmlContent: `
      <p>Với quà sinh nhật, độ dài dây chuyền thường quyết định độ dễ dùng nhiều hơn mặt đá lớn hay nhỏ.</p>
      <p>Nếu chưa chắc phong cách người nhận, nên ưu tiên chiều dài trung tính và mặt điểm nhấn vừa phải để giảm rủi ro đổi trả.</p>
    `,
  }),
  createNewsItem({
    id: "news-07",
    title: "Bảo quản vàng 18K đúng cách khi thời tiết nóng ẩm kéo dài",
    slug: "bao-quan-vang-18k-dung-cach-khi-thoi-tiet-nong-am-keo-dai",
    excerpt:
      "Mồ hôi, mỹ phẩm và môi trường ẩm là ba tác nhân khiến trang sức nhanh xỉn nếu không vệ sinh và cất giữ đúng cách.",
    sapo: "Mồ hôi, mỹ phẩm và môi trường ẩm là ba tác nhân khiến trang sức nhanh xỉn nếu không vệ sinh và cất giữ đúng cách.",
    image:
      "https://images.unsplash.com/photo-1610375461369-d613b5649288?auto=format&fit=crop&w=1400&q=80",
    category: "Kiến thức bảo quản",
    categorySlug: "kien-thuc-bao-quan",
    publishedAt: "2026-04-13T15:20:00.000Z",
    author: "Bộ phận CSKH",
    htmlContent: `
      <p>Thời tiết nóng ẩm làm vàng 18K dễ bám mồ hôi, mỹ phẩm và bụi mịn, khiến bề mặt mất độ sáng nhanh hơn.</p>
      <h3>Cách xử lý</h3>
      <ul>
        <li>Lau nhẹ bằng khăn mềm sau khi đeo.</li>
        <li>Không để chung với nhiều món có bề mặt cứng.</li>
        <li>Bảo dưỡng định kỳ tại cửa hàng để kiểm tra ngàm, khóa và bề mặt.</li>
      </ul>
    `,
  }),
  createNewsItem({
    id: "news-08",
    title: "Khi nào nên đánh bóng lại nhẫn đeo hằng ngày để không mòn form",
    slug: "khi-nao-nen-danh-bong-lai-nhan-deo-hang-ngay-de-khong-mon-form",
    excerpt:
      "Đánh bóng quá dày dễ làm hao bề mặt, nhưng để quá lâu lại khiến vết xước nhỏ tích tụ thành cảm giác cũ nhanh hơn.",
    sapo: "Đánh bóng quá dày dễ làm hao bề mặt, nhưng để quá lâu lại khiến vết xước nhỏ tích tụ thành cảm giác cũ nhanh hơn.",
    image:
      "https://images.unsplash.com/photo-1611599537845-1c7aca0091c0?auto=format&fit=crop&w=1400&q=80",
    category: "Kiến thức bảo quản",
    categorySlug: "kien-thuc-bao-quan",
    publishedAt: "2026-04-12T09:30:00.000Z",
    author: "Bộ phận CSKH",
    htmlContent: `
      <p>Đánh bóng định kỳ là cần thiết, nhưng tần suất quá dày có thể làm hao mòn bề mặt nếu sản phẩm phải xử lý cơ học nhiều lần.</p>
      <p>Với nhẫn đeo hàng ngày, mốc bảo dưỡng hợp lý thường là vài tháng một lần tùy cường độ sử dụng và mức độ xước thực tế.</p>
    `,
  }),
  createNewsItem({
    id: "news-09",
    title: "5 lỗi cất giữ trang sức khiến đá đính dễ xô lệch hơn bạn nghĩ",
    slug: "5-loi-cat-giu-trang-suc-khien-da-dinh-de-xo-lech-hon-ban-nghi",
    excerpt:
      "Bỏ chung nhiều món trong một hộp nhỏ là nguyên nhân phổ biến khiến càng đá cọ nhau và phát sinh lệch chân giữ.",
    sapo: "Bỏ chung nhiều món trong một hộp nhỏ là nguyên nhân phổ biến khiến càng đá cọ nhau và phát sinh lệch chân giữ.",
    image:
      "https://images.unsplash.com/photo-1617038220319-276d3cfab638?auto=format&fit=crop&w=1400&q=80",
    category: "Kiến thức bảo quản",
    categorySlug: "kien-thuc-bao-quan",
    publishedAt: "2026-04-10T13:50:00.000Z",
    author: "Bộ phận CSKH",
    htmlContent: `
      <p>Cất nhiều món trong cùng một hộp nhỏ là lỗi phổ biến khiến đá đính, càng giữ và bề mặt ma sát liên tục với nhau.</p>
      <p>Nên chia ngăn hoặc dùng túi mềm riêng cho từng món, đặc biệt với các thiết kế có mặt đá nổi hoặc cạnh sắc.</p>
    `,
  }),
  createNewsItem({
    id: "news-10",
    title: "Những bộ đôi nhẫn và vòng tay tối giản đang dẫn đầu tỷ lệ mua kèm",
    slug: "nhung-bo-doi-nhan-va-vong-tay-toi-gian-dang-dan-dau-ty-le-mua-kem",
    excerpt:
      "Khách mua online phản hồi tốt với set có cùng ngôn ngữ thiết kế và giá nằm trong một khoảng dễ so sánh.",
    sapo: "Khách mua online phản hồi tốt với set có cùng ngôn ngữ thiết kế và giá nằm trong một khoảng dễ so sánh.",
    image:
      "https://images.unsplash.com/photo-1611652022419-a9419f74343d?auto=format&fit=crop&w=1400&q=80",
    category: "Xu hướng",
    categorySlug: "xu-huong",
    publishedAt: "2026-04-09T10:15:00.000Z",
    author: "ERP GOLD Editorial",
    htmlContent: `
      <p>Set nhẫn và vòng tay tối giản đang dẫn đầu tỷ lệ mua kèm vì dễ hiểu, dễ mix-match và phù hợp nhiều độ tuổi.</p>
      <p>Các bộ đôi có cấu trúc hình học rõ, ít chi tiết thừa thường hiển thị tốt trong card listing và ads hình dọc.</p>
    `,
  }),
  createNewsItem({
    id: "news-11",
    title:
      "Tặng trang sức cho khách doanh nghiệp: nên chọn sản phẩm khắc tên hay mẫu trung tính",
    slug: "tang-trang-suc-cho-khach-doanh-nghiep-nen-chon-san-pham-khac-ten-hay-mau-trung-tinh",
    excerpt:
      "Đơn quà doanh nghiệp thường tối ưu hơn khi tách sản phẩm nền và dịch vụ cá nhân hóa thành hai lựa chọn chốt riêng.",
    sapo: "Đơn quà doanh nghiệp thường tối ưu hơn khi tách sản phẩm nền và dịch vụ cá nhân hóa thành hai lựa chọn chốt riêng.",
    image:
      "https://images.unsplash.com/photo-1617038220319-276d3cfab638?auto=format&fit=crop&w=1400&q=80",
    category: "Tư vấn chọn mua",
    categorySlug: "tu-van-chon-mua",
    publishedAt: "2026-04-08T16:05:00.000Z",
    author: "Minh An",
    htmlContent: `
      <p>Quà doanh nghiệp thường hiệu quả hơn khi tách sản phẩm nền và dịch vụ khắc tên thành hai lựa chọn riêng để dễ chốt số lượng lớn.</p>
      <p>Mẫu trung tính giúp giảm sai lệch gu thẩm mỹ, còn khắc tên nên là tùy chọn bổ sung cho nhóm khách cần cá nhân hóa mạnh.</p>
    `,
  }),
  createNewsItem({
    id: "news-12",
    title:
      "Có nên tự làm sạch bạc tại nhà mỗi tuần hay để cửa hàng bảo dưỡng định kỳ",
    slug: "co-nen-tu-lam-sach-bac-tai-nha-moi-tuan-hay-de-cua-hang-bao-duong-dinh-ky",
    excerpt:
      "Làm sạch quá thường bằng hóa chất mạnh có thể khiến bề mặt bạc mất độ sáng tự nhiên và nhanh khô hơn.",
    sapo: "Làm sạch quá thường bằng hóa chất mạnh có thể khiến bề mặt bạc mất độ sáng tự nhiên và nhanh khô hơn.",
    image:
      "https://images.unsplash.com/photo-1535632066927-ab7c9ab60908?auto=format&fit=crop&w=1400&q=80",
    category: "Kiến thức bảo quản",
    categorySlug: "kien-thuc-bao-quan",
    publishedAt: "2026-04-07T08:40:00.000Z",
    author: "Bộ phận CSKH",
    htmlContent: `
      <p>Tự làm sạch bạc tại nhà có thể hữu ích, nhưng làm quá thường bằng hóa chất mạnh sẽ khiến bề mặt bạc nhanh khô và mất ánh sáng tự nhiên.</p>
      <p>Giải pháp cân bằng là lau nhẹ tại nhà và kết hợp bảo dưỡng định kỳ tại cửa hàng khi bề mặt bắt đầu xuống màu rõ rệt.</p>
    `,
  }),
];

export const mockCollectionPages: MockCollectionPage[] = [
  {
    slug: "di-san-vang-kim",
    title: "Di sản vàng kim",
    description:
      "Bộ sưu tập ưu tiên vàng 24K và các thiết kế giữ giá trị tích lũy, phù hợp khách mua quà tặng hoặc lưu giữ dài hạn.",
    highlights: [
      "Vàng 24K cao cấp",
      "Thiết kế bền giá trị",
      "Ưu tiên nhóm quà tặng tích lũy",
    ],
    filters: {
      goldType: "24K",
      sortBy: "newest",
    },
  },
  {
    slug: "silver-night",
    title: "Silver night edit",
    description:
      "Nhóm thiết kế thanh mảnh, dễ phối trang phục hằng ngày, ưu tiên các dòng 14K và 18K cho khách mua online.",
    highlights: [
      "Form mảnh dễ đeo",
      "Ưu tiên 14K và 18K",
      "Dễ bán kèm theo set",
    ],
    filters: {
      goldType: "14K",
      sortBy: "price_asc",
    },
  },
  {
    slug: "qua-tang",
    title: "Quà tặng mùa lễ hội",
    description:
      "Tổng hợp các mẫu dễ chốt quà tặng, set trang sức và sản phẩm có tỷ lệ bán tốt cho các dịp cưới hỏi, sinh nhật và kỷ niệm.",
    highlights: [
      "Set quà dễ chốt",
      "Có thể cá nhân hóa",
      "Phù hợp nhiều ngân sách",
    ],
    filters: {
      category: "sets",
      sortBy: "best_selling",
    },
  },
];

export const mockPolicyPages: PolicyPage[] = [
  createPolicyPage({
    slug: "chinh-sach-bao-hanh",
    title: "Chính sách bảo hành",
    description:
      "Điều kiện tiếp nhận, thời gian xử lý và các trường hợp phát sinh chi phí đối với sản phẩm kim hoàn.",
    sapo: "Thông tin bảo hành giúp khách hàng chủ động kiểm tra tình trạng sản phẩm, làm sạch định kỳ và gửi yêu cầu nhanh hơn sau mua.",
    updatedAt: "2026-04-21T08:00:00.000Z",
    thumbnail: "/home/ancarat-gold.jpg",
    htmlContent: `
      <h3>Phạm vi áp dụng</h3>
      <p>Tất cả sản phẩm mua tại storefront ERP GOLD đều được tiếp nhận kiểm tra tình trạng, vệ sinh cơ bản và tư vấn bảo quản theo dòng hàng tương ứng.</p>
      <h3>Thời gian xử lý</h3>
      <ul>
        <li>Kiểm tra tình trạng ban đầu: trong ngày làm việc.</li>
        <li>Bảo hành kỹ thuật tiêu chuẩn: từ 3 đến 7 ngày làm việc.</li>
        <li>Các trường hợp cần gia công lại hoặc thay thế linh kiện sẽ được báo thời gian riêng.</li>
      </ul>
      <h3>Lưu ý phát sinh chi phí</h3>
      <p>Các trường hợp móp méo do va đập mạnh, thay đổi form ngoài chuẩn, thiếu linh kiện hoặc hao hụt ngoài giới hạn kỹ thuật có thể phát sinh chi phí sau khi kỹ thuật viên xác nhận.</p>
    `,
  }),
  createPolicyPage({
    slug: "chinh-sach-giao-hang",
    title: "Chính sách giao hàng",
    description:
      "Quy định đóng gói, phạm vi giao nhận, thời gian dự kiến và nguyên tắc kiểm tra khi nhận hàng.",
    sapo: "ERP GOLD hỗ trợ giao hàng toàn quốc với tiêu chuẩn đóng gói an toàn và xác nhận tình trạng niêm phong trước khi bàn giao.",
    updatedAt: "2026-04-20T10:00:00.000Z",
    thumbnail: "/home/ancarat-flashsale.png",
    htmlContent: `
      <h3>Phạm vi phục vụ</h3>
      <p>Đơn hàng được giao trên toàn quốc qua đối tác vận chuyển có theo dõi hành trình và hỗ trợ đối soát khi nhận.</p>
      <h3>Đóng gói tiêu chuẩn</h3>
      <p>Sản phẩm được niêm phong, kèm phiếu thông tin hàng hóa và hướng dẫn kiểm tra trước khi ký nhận.</p>
      <h3>Kiểm tra khi nhận hàng</h3>
      <ul>
        <li>Đối chiếu mã đơn, tên người nhận và tình trạng niêm phong.</li>
        <li>Quay video mở hộp nếu phát hiện bất thường.</li>
        <li>Liên hệ ngay bộ phận chăm sóc khách hàng trong vòng 24 giờ nếu có sai lệch.</li>
      </ul>
    `,
  }),
  createPolicyPage({
    slug: "chinh-sach-doi-tra",
    title: "Chính sách đổi trả",
    description:
      "Điều kiện đổi size, đổi mẫu và quy trình xử lý các yêu cầu đổi trả phát sinh sau khi nhận hàng.",
    sapo: "Chính sách đổi trả được thiết kế để giảm rủi ro cho khách mua online nhưng vẫn đảm bảo tình trạng hàng hóa đủ điều kiện tiếp nhận lại.",
    updatedAt: "2026-04-18T15:30:00.000Z",
    thumbnail: "/home/ancarat-silver.jpg",
    htmlContent: `
      <h3>Điều kiện tiếp nhận</h3>
      <p>Sản phẩm còn nguyên tem, phụ kiện đi kèm, không có dấu hiệu đã sử dụng ngoài mức kiểm tra thông thường và còn trong thời hạn áp dụng được công bố tại thời điểm mua.</p>
      <h3>Trường hợp hỗ trợ</h3>
      <ul>
        <li>Đổi size nhẫn theo giới hạn kỹ thuật của từng mẫu.</li>
        <li>Đổi sang sản phẩm khác khi đơn chưa qua gia công cá nhân hóa.</li>
        <li>Hỗ trợ xác minh lỗi kỹ thuật nếu có khác biệt so với thông tin đã xác nhận.</li>
      </ul>
      <h3>Trường hợp từ chối</h3>
      <p>Không áp dụng với sản phẩm khắc tên, thiết kế riêng hoặc đã có thay đổi kết cấu sau khi bàn giao cho khách hàng.</p>
    `,
  }),
  createPolicyPage({
    slug: "chinh-sach-bao-mat",
    title: "Chính sách bảo mật",
    description:
      "Nguyên tắc thu thập, lưu trữ và sử dụng thông tin khách hàng trong quá trình đặt hàng và chăm sóc sau bán.",
    sapo: "ERP GOLD chỉ sử dụng dữ liệu khách hàng cho các mục đích cần thiết nhằm xử lý đơn hàng, hỗ trợ bảo hành và cải thiện trải nghiệm mua sắm.",
    updatedAt: "2026-04-17T09:00:00.000Z",
    thumbnail: "/home/ancarat-gold.jpg",
    htmlContent: `
      <h3>Dữ liệu được thu thập</h3>
      <p>Thông tin liên hệ, địa chỉ nhận hàng, lịch sử đơn hàng và các tương tác chăm sóc khách hàng cần thiết để xử lý giao dịch.</p>
      <h3>Mục đích sử dụng</h3>
      <ul>
        <li>Xác nhận đơn hàng và giao nhận.</li>
        <li>Liên hệ hỗ trợ bảo hành, đổi trả hoặc chăm sóc sau mua.</li>
        <li>Gửi thông tin cập nhật dịch vụ khi khách hàng đồng ý nhận thông báo.</li>
      </ul>
      <h3>Cam kết bảo mật</h3>
      <p>ERP GOLD không chia sẻ thông tin cá nhân cho bên thứ ba ngoài phạm vi cần thiết để vận hành đơn hàng và các nghĩa vụ pháp lý liên quan.</p>
    `,
  }),
  createPolicyPage({
    slug: "dieu-khoan-su-dung",
    title: "Điều khoản sử dụng",
    description:
      "Các điều kiện chung khi khách hàng truy cập, đặt hàng và sử dụng thông tin trên storefront ERP GOLD.",
    sapo: "Việc truy cập và sử dụng website đồng nghĩa với việc khách hàng đồng ý với các nguyên tắc vận hành, giới hạn trách nhiệm và quy định cập nhật nội dung.",
    updatedAt: "2026-04-15T11:45:00.000Z",
    thumbnail: "/home/ancarat-flashsale.png",
    htmlContent: `
      <h3>Phạm vi thông tin</h3>
      <p>Hình ảnh, giá niêm yết và mô tả sản phẩm trên storefront được cập nhật thường xuyên nhưng có thể thay đổi theo tồn kho, giá nguyên liệu và chương trình bán hàng.</p>
      <h3>Trách nhiệm của người dùng</h3>
      <ul>
        <li>Cung cấp thông tin đặt hàng chính xác và cập nhật.</li>
        <li>Không sử dụng website cho mục đích gian lận, phá hoại hoặc xâm phạm quyền lợi của bên khác.</li>
        <li>Kiểm tra kỹ nội dung đơn hàng trước khi xác nhận thanh toán.</li>
      </ul>
      <h3>Quyền cập nhật</h3>
      <p>ERP GOLD có quyền điều chỉnh nội dung, điều kiện áp dụng và chính sách vận hành khi cần thiết để phù hợp với thực tế kinh doanh.</p>
    `,
  }),
];

export const findMockCollectionPage = (slug?: string) =>
  mockCollectionPages.find((item) => item.slug === slug);

export const findMockPolicyPage = (slug?: string) =>
  mockPolicyPages.find((item) => item.slug === slug);

export const getMockPolicyNavigation = (): PolicyNavItem[] =>
  mockPolicyPages.map((page) => ({
    slug: page.slug,
    title: page.title,
    href: buildPolicyPath(page.slug),
  }));

export const getMockLatestNews = (limit = 5) =>
  mockNewsArticles.slice(0, Math.max(0, limit));

export const findMockNewsArticle = (slug?: string) =>
  mockNewsArticles.find((item) => item.slug === slug) ?? null;

export const getMockNewsListing = (
  query: NewsListQuery = {},
): NewsListResult => {
  const categories = [...mockNewsCategories];
  const selectedCategory =
    categories.find((item) => item.slug === query.categorySlug) ?? null;
  const filteredItems = selectedCategory
    ? mockNewsArticles.filter(
        (item) => item.categorySlug === selectedCategory.slug,
      )
    : mockNewsArticles;
  const limit = toPositiveInteger(query.limit, NEWS_PAGE_SIZE);
  const total = filteredItems.length;
  const totalPages = Math.max(1, Math.ceil(total / limit));
  const page = Math.min(toPositiveInteger(query.page, 1), totalPages);
  const startIndex = (page - 1) * limit;

  return {
    categories,
    items: filteredItems.slice(startIndex, startIndex + limit),
    page,
    limit,
    total,
    totalPages,
    selectedCategory,
    seo: NEWS_LISTING_SEO,
  };
};
